import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import React from "react";

function Dashboardcard({ image, title, count }) {
  return (
    <SoftBox
      borderRadius="md"
      p={3}
      border="1px solid #D8E0E8"
      sx={{
        backgroundColor: "skyblue.main",
        alignItems: "center",
        justifyContent: "space-between",
      }}
      display="flex"
      width="100%"
    >
      <SoftBox
        display="flex"
        flexDirection="column"
        alignItems="start"
        justifyContent="space-between"
        height={100}
        gap={3}
      >
        <SoftTypography color="black" fontWeight="bold" sx={{ fontSize: 16 }}>
          {title}
        </SoftTypography>

        <SoftTypography color="primary" fontWeight="bold" sx={{ fontSize: 40 }}>
          {count}
        </SoftTypography>
      </SoftBox>

      <SoftBox>
        <SoftBox
          component="img"
          src={image}
          alt={title}
          height="60px"
          width="60px"
          sx={{
            objectFit: "contain",
            display: "block",
          }}
        />
      </SoftBox>
    </SoftBox>
  );
}

export default Dashboardcard;
